module.exports = __webpack_public_path__ + "img/tree_remove.afc084bb.svg";